export const zhCommon = {
  siteName: '国产91视频',
  siteTagline: '国产创意短视频与国内原创视频社区',
  nav: {
    home: '首页',
    categories: '分类',
    about: '关于我们',
    search: '搜索',
  },
  hero: {
    title: '发现国产好视频',
    subtitle: '汇集国内创作者自制的创意短视频、微电影和搞笑视频',
    ctaPrimary: '浏览热门视频',
    ctaSecondary: '了解我们',
  },
  categories: {
    title: '探索视频分类',
    subtitle: '六大精选分类，总有一个适合你',
  },
  trending: {
    title: '热门推荐',
    subtitle: '本周最受关注的国产原创视频',
  },
  creators: {
    title: '精选创作者',
    subtitle: '认识这些才华横溢的国内原创视频作者',
    cta: '查看全部创作者',
    followers: '粉丝',
    videos: '作品',
  },
  testimonial: {
    label: '用户评价',
    title: '来自社区的真实声音',
  },
  cta: {
    title: '准备好发现好视频了吗？',
    button: '立即开始探索',
    description: '加入数百万用户的行列，一起发现国产原创视频的魅力',
  },
  footer: {
    description: '国产91视频是国内领先的原创短视频发现平台，致力于挖掘和展示最优秀的国产自制视频内容。',
    links: {
      about: '关于我们',
      contact: '联系我们',
      privacy: '隐私政策',
      terms: '使用条款',
      creators: '创作者计划',
      help: '帮助中心',
    },
    social: {
      weibo: '微博',
      wechat: '微信公众号',
      bilibili: '哔哩哔哩',
      douyin: '抖音',
    },
    copyright: '国产91视频 版权所有',
  },
  video: {
    views: '次播放',
    likes: '点赞',
    duration: '时长',
    creator: '创作者',
    publishedAt: '发布于',
    related: '相关推荐',
    share: '分享',
    report: '举报',
  },
  breadcrumb: {
    home: '首页',
  },
  notFound: {
    title: '页面未找到',
    description: '抱歉，你访问的页面不存在或已被移除。',
    backHome: '返回首页',
  },
  category: {
    notFound: '分类未找到',
    videoCount: '共 {{count}} 个视频',
    otherCategories: '其他分类:',
    empty: '该分类暂无视频',
    browseOther: '返回首页浏览其他内容',
  },
  videoDetail: {
    notFound: '视频未找到',
    description: '视频简介',
    play: '播放视频',
    plays: '次播放',
  },
  about: {
    title: '关于国产91视频',
    brandTitle: '品牌介绍',
    reputationTitle: '口碑与评价',
    contactTitle: '联系我们',
    mission: '我们的使命',
    vision: '我们的愿景',
    values: '我们的价值观',
    faq: '常见问题',
  },
};

export default zhCommon;